var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"d-flex m-0 text-left",class:!_vm.$isWealthTime && 'small',domProps:{"innerHTML":_vm._s(_vm.companyRegistration)}})}
var staticRenderFns = []

export { render, staticRenderFns }